export default class PausableAdTimer {
    constructor(callback, delay) {
        this.callback = callback;
        this.initialDelay = delay;
        this.isPaused = true;
        this.remaining = delay;
    }
    clear() {
        clearTimeout(this.timerId);
        this.isPaused = true;
        this.remaining = this.initialDelay;
        delete this.lastResume;
        delete this.timerId;
    }
    pause() {
        clearTimeout(this.timerId);
        this.isPaused = true;
        this.remaining -= Date.now() - this.lastResume;
    }
    resume() {
        clearTimeout(this.timerId);
        this.isPaused = false;
        this.lastResume = Date.now();
        this.timerId = setTimeout(this.callback, this.remaining);
    }
}
